<form #f="ngForm" style="width: 100%;">
  <div class="metadata-container">
    @if (document) {
      <div class="metadata-scroller" pFocusTrap>
        <div class="grid grid-nogutter" >
          <div class="col-12 md:col-12 metadata-cell">
            @if (mode==='normal' && document.is_modifiable) {
              <button pButton pRipple i18n-label="@@common-delete" label="Delete" icon="fa fa-regular fa-trash-can" (click)="onDelete()" severity="danger" class="mr-1"></button>
            }
            @if (mode==='edition') {
              <button pButton pRipple i18n-label="@@common-cancel" label="Cancel" icon="fa fa-solid fa-xmark" (click)="onCancel()" severity="secondary" class="mr-1"></button>
            }
            @if (mode==='normal') {
              <button pButton pRipple i18n-label="@@common-history" label="History" icon="fa fa-solid fa-clock-rotate-left" (click)="onClickHistory(document.uuid)"
                severity="secondary" class="mr-1"></button>
            }
            @if (document.state.name === 'new' && !bulkMode) {
              <button pButton pRipple i18n-label="@@metadata-validate" label="Validate" icon="fa fa-solid fa-check" (click)="onValidate()" severity="success" class="mr-1"
                [disabled]="mode !== 'normal' || !document.type || formIsIncomplete()"></button>
            }
            @if (mode==='normal' && document.is_modifiable) {
              <button pButton pRipple i18n-label="@@common-edit" label="Edit" icon="fa fa-solid fa-pencil" (click)="onEdit()" class="mr-1"></button>
            }
            @if (mode==='edition') {
              <button pButton pRipple i18n-label="@@common-save" label="Save" icon="fa fa-regular fa-floppy-disk" (click)="onSave()" class="mr-1"
                [disabled]="!detailForm.valid || !document.type"></button>
            }
          </div>
          @if (mode==='edition') {
            <div class="col-12 md:col-5 metadata-cell">
              <span class="field-label" i18n="@@metadata-show-all-types">Show all document types</span>
              <i [pTooltip]="toolTips['showAllTypes']" class="fa fa-solid fa-circle-info metadata-info mr-3"></i>
            </div>
            <div class="col-12 md:col-7 metadata-cell">
              <p-checkbox [(ngModel)]="showAllDocTypes" name="showAllDocTypes" [binary]="true" (onChange)="onShowAllDocTypesChange()"></p-checkbox>
            </div>
          }
          <div class="col-12 md:col-5 metadata-cell">
            <div class="field-label" i18n="@@metadata-document-type">Document type</div>
          </div>
          <div class="col-12 md:col-7 metadata-cell">
            <p-select #dropdown [(ngModel)]="document.type" name="type" [disabled]="mode !== DetailMode.EDITION"
              [options]="documentTypeGroups" dataKey="code" [group]="true"
              [filter]="true" filterBy="label" appendTo="body"
              [showClear]="true" i18n-placeholder="@@common-none" placeholder="(none)" scrollHeight="300px" (onChange)="recomputeDocumentFields()"
              class="acted-highlight-req metadata-field" [tabindex]="0">
              <ng-template let-item pTemplate="item">
                <div class="item">
                  @if (item.value?.batch) {
                    <p-tag severity="warn" i18n="@@metadata-batch-caps">BATCH</p-tag>
                  }
                  {{ item.label }}
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>
        @if (document.type) {
          <div>
            <!-- generic form -->
            <div>
              <app-type-generic [document]="document" [documentFields]="documentFields" [mode]="mode" [respectRequired]="respectRequired"></app-type-generic>
            </div>
          </div>
        }
      </div>
    }
  </div>
</form>
